import { css } from '@emotion/css';

import { Colors, Spacing } from 'apps/shared/scripts/styles/constants';

export const previewClassName = css({
  alignItems: 'flex-start',
  display: 'flex',
  marginTop: Spacing.XS,
});

export const innerClassName = css({
  position: 'relative',
});

export const actionClassName = css({
  position: 'absolute',
  top: 10,
  right: 10,
  zIndex: 1,
});

export const buttonClassName = css({
  background: 'rgba(74, 74, 244, 0.8)',
  padding: Spacing['2XS'] + 2,
  '&:hover': {
    background: 'rgb(74, 74, 244)',
  },
});

export const iconClassName = css({
  color: Colors.White,
  height: 16,
  width: 16,
});

export const imageClassName = css({
  borderRadius: 4,
  '& .image-img': {
    height: 160,
    width: 'auto',
  },
});
